export const absenceJustificationOnDate = (person, value) => {
  const day = String(value || '').slice(0, 10);
  const items = person?.customFields?.__absenceJustifications;
  if (!day || !Array.isArray(items)) return null;
  return items.find((item) => {
    const start = String(item?.startDate || '').slice(0, 10);
    const end = String(item?.endDate || item?.startDate || '').slice(0, 10);
    return start && end && day >= start && day <= end;
  }) || null;
};
